import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../_actions/dataActions";
import PageSubTitle from "../../../UI/PageSubTitle";
import EditWidget from "../../../UI/EditWidget";
import Wrapper from "../../../../_hoc/Wrapper";
import Select from "../../../UI/Select";
import getJobType from "../../../../_selectors/dataSelectors/getJobType";
import getIncome from "../../../../_selectors/dataSelectors/getIncome";
import getEducation from "../../../../_selectors/dataSelectors/getEducation";
import getEmployedIn from "../../../../_selectors/dataSelectors/getEmployedIn";

class Professional extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.preference) {
      const { jobType, income, education, employedIn } = nextProps.preference;
      const {
        isEditModeOn,
        selectedJobType,
        selectedIncome,
        selectedEducation,
        selectedEmployedIn
      } = prevState;
      if (isEditModeOn) {
        return null;
      } else {
        if (
          jobType !== selectedJobType ||
          income !== selectedIncome ||
          education !== selectedEducation ||
          employedIn !== selectedEmployedIn
        ) {
          return {
            selectedEducation: education,
            selectedEmployedIn: employedIn,
            selectedIncome: income,
            selectedJobType: jobType
          };
        } else {
          return null;
        }
      }
    } else {
      null;
    }
  }
  state = {
    isEditModeOn: false,
    selectedJobType: [],
    selectedIncome: [],
    selectedEducation: [],
    selectedEmployedIn: []
  };
  componentDidMount() {
    const {
      jobType,
      getJobTypeData,
      income,
      getIncomeData,
      education,
      getEducationData,
      employedIn,
      getEmployedInData
    } = this.props;
    if (jobType.length === 0) {
      getJobTypeData();
    }
    if (income.length === 0) {
      getIncomeData();
    }
    if (education.length === 0) {
      getEducationData();
    }
    if (employedIn.length === 0) {
      getEmployedInData();
    }
  }
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const {
      selectedEducation,
      selectedEmployedIn,
      selectedIncome,
      selectedJobType
    } = this.state;
    const { update } = this.props;

    const updatedPreference = {
      education: selectedEducation,
      employedIn: selectedEmployedIn,
      income: selectedIncome,
      jobType: selectedJobType
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
    };
    const onError = err => {
      console.log(err);
    };
    update({ data: updatedPreference, onSuccess, onError });
  };
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  render() {
    const {
      isEditModeOn,
      selectedEmployedIn,
      selectedIncome,
      selectedJobType,
      selectedEducation
    } = this.state;
    const { jobType, income, education, employedIn, preference } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Professional Preference
            <EditWidget
              show
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={preference.cache}
            />
          </h3>
          <p />
        </PageSubTitle>

        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Education</Wrapper>}
                selected={selectedEducation}
                options={education}
                onChange={value => {
                  this.setState({ selectedEducation: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <Select
                label={<Wrapper>Employed In</Wrapper>}
                selected={selectedEmployedIn}
                options={employedIn}
                onChange={value => {
                  this.setState({ selectedEmployedIn: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Select
                label={<Wrapper>Job Type</Wrapper>}
                selected={selectedJobType}
                options={jobType}
                onChange={value => {
                  this.setState({ selectedJobType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-8">
              <Select
                label={<Wrapper>Income</Wrapper>}
                selected={selectedIncome}
                options={income}
                onChange={value => {
                  this.setState({ selectedIncome: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  jobType: getJobType(state),
  income: getIncome(state),
  education: getEducation(state),
  employedIn: getEmployedIn(state)
});
const mapDispatchToProps = dispatch => ({
  getJobTypeData: () => dispatch(dataActions.getJobType()),
  getIncomeData: () => dispatch(dataActions.getIncome()),
  getEducationData: () => dispatch(dataActions.getEducation()),
  getEmployedInData: () => dispatch(dataActions.getEmployedIn())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Professional);



// WEBPACK FOOTER //
// ./src/_components/Profile/PartnerPreference/Professional/index.js